import { render } from "./Notifications.vue?vue&type=template&id=b7f62612"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Notifications.vue?vue&type=style&index=0&id=b7f62612&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__